<template>
    <div class="modal modal-text fade in show" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <div class="modal-inner">
                    <h5 class="title">Terms and Conditions</h5>
                    <p style="text-decoration: underline;"><b>By receiving your payments via direct deposit or International Bank Wire Transfer, you acknowledge and agree to the following:</b></p>
                    <p>"You agree to have your payments directly deposited into your back account as indicated above. You authorize First Class Entertainment Inc. (as payor) to initiate electronic entries and, if necessary, debit entries and adjustments for any credit entries in error to your account each pay period. This authority will remain in effect until I notify First Class Entertainment Inc. in writing or as otherwise specified by First Class Entertainment Inc."</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TermsAndConditions',
    props: {
        modalId: String
    }

}

</script>



<style scoped>

</style>
